// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__xKfl_","light":"Icon_light___VGdK","xs":"Icon_xs__TF9XS","sm":"Icon_sm__zAaBh","md":"Icon_md__FO4IW","lg":"Icon_lg__56dso","xl":"Icon_xl__43eMs"};